<people-table #viewAll [allowFocusChange]="true"></people-table>
